<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="headerTitle"
      :header-content="$t('WEB_SOURCES.SCRAPE_SOURCE.DESCRIPTION')"
    />
    <form class="row" @submit.prevent="submitCreateScrapeWebsite">
      <div class="medium-12 body-content bg-slate-75 border border-slate-50">
        <input
          type="text"
          :placeholder="$t('WEB_SOURCES.SCRAPE_SOURCE.PLACEHOLDER_INPUT')"
          v-model="url"
        />
        <div class="process">
          <img
            src="~dashboard/assets/images/file-link.svg"
            alt=""
          />
          <img
            v-if="step === 1"
            src="~dashboard/assets/images/dot.svg"
            alt=""
          />
          <div v-if="step === 1" class="bar"/>
          <img
            v-if="step === 2"
            src="~dashboard/assets/images/check-circle.svg"
            alt=""
          />
        </div>

        <div class="sub-title">
          <h2 v-if="step === 0">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_TITLE") }}
          </h2>
          <p v-if="step === 0">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_DESCRIPTION") }}
          </p>
          <h2 v-if="step === 1">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_TITLE2") }}
          </h2>
          <p v-if="step === 1">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_DESCRIPTION2") }}
          </p>
          <h2 v-if="step === 2">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_TITLE3") }}
          </h2>
          <p v-if="step === 2">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.SUB_DESCRIPTION3") }}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <div class="medium-12 columns" v-if="step === 0">
          <woot-button
            :is-disabled="!(url && isValid)"
            @click.prevent="onScape"
          >
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.SUBMIT") }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.CANCEL") }}
          </woot-button>
        </div>
        <div class="medium-12 columns" v-if="step === 1">
          <woot-button
            :is-disabled="!(url && isValid)"
            @click.prevent="onClose"
          >
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.HIDE") }}
          </woot-button>
          <woot-button
            class="button clear text-red-700"
            @click.prevent="onClose"
          >
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.ABORT") }}
          </woot-button>
        </div>
        <div class="medium-12 columns" v-if="step === 2">
          <woot-button
            @click.prevent="viewLatestWebUrls"
          >
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.REVIEW") }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t("WEB_SOURCES.SCRAPE_SOURCE.ACTIONS.DONE") }}
          </woot-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from "shared/mixins/alertMixin";
import { isValidURL} from "../../../../helper/URLHelper";

export default {
  components: {
  },
  mixins: [alertMixin],
  props: {
    currentWeb: {
      type: Object,
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      url: this.currentWeb.url,
      creating: false,
      step: 0,
    };
  },
  computed: {
    ...mapGetters({
      webList: 'webs/getWebs',
    }),
    isValid() {
      if (this.url) {
        return isValidURL(this.url);
      }
      if (!this.file) {
        return false;
      }
    },
  },
  mounted() {
    this.url = this.currentWeb.url || ''
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onScape() {
      this.step = 1;
      this.creating = true;
      this.submitCreateScrapeWebsite();
    },
    async submitCreateScrapeWebsite() {
      try {
        if (this.currentWeb && this.currentWeb.id) {
          await this.$store.dispatch('webs/update', {id: this.currentWeb.id, url: this.url});

          this.showAlert(
            this.$t('WEB_SOURCES.ACTIONS.EDIT.SUCCESS_MESSAGE')
          );
        } else {
          await this.$store.dispatch("webs/create", { url: this.url });

          this.showAlert(
            this.$t("WEB_SOURCES.ACTIONS.CREATE.SUCCESS_MESSAGE")
          );
        }

        this.step = 2;
        this.creating = false;
      } catch (error) {
        if (this.currentWeb && this.currentWeb.id) {
          this.showAlert(
            this.$t("WEB_SOURCES.ACTIONS.EDIT.ERROR_MESSAGE")
          );
        } else {
          this.showAlert(
            this.$t("WEB_SOURCES.ACTIONS.CREATE.ERROR_MESSAGE")
          );
        }
      }
    },
    viewLatestWebUrls() {
      this.$router.push({ path: 'webs/' + this.webList.[0].id })
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-footer {
  .button {
    margin-right: var(--space-small);
    margin-left: 0;
  }
}
.body-content {
  padding: var(--space-large);
  border: 1px solid var(--s-75);
  background: var(--s-75);
}
.sub-title {
  margin-top: var(--space-small);
  h2,
  p {
    font-size: var(--font-size-default);
  }
}
input {
  border-radius: var(--space-small);
  font-size: var(--font-size-default);
  padding-left: var(--space-two);
  height: var(--space-larger);
}
.process {
  display: flex;
  align-items: center;
}
.bar {
  height: 4px;
  background: #E6E6ED;
  flex: 1 0 0;
}
.abort {
  color: var(--r-700);
}
</style>
